import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class SizeText {
    _firstDot: marietta.core.Point;

    get firstDot() { return this._firstDot; }

    set firstDot(_dot) {
      this._firstDot = _dot;
      this.updateTransforms();
    }

    _secondDot: marietta.core.Point;

    get secondDot() { return this._secondDot; }

    set secondDot(_dot) {
      this._secondDot = _dot;
      this.updateTransforms();
    }

    // 1.5Pくらいで見せる
    minVisibleDistance: number = 90;

    public spt: SVGSprite;

    public spt2: SVGSprite;

    /**
     * コンストラクタ
     * */
    constructor(targetSprite: SVGSprite) {
      const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      viewObj.setAttribute('id', 'size_text');
      viewObj.setAttribute('fill', '#000000');
      this.spt = new SVGSprite(viewObj);

      const viewObj2: Element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      viewObj2.setAttribute('id', 'size_text2');
      viewObj2.setAttribute('fill', '#000000');
      this.spt2 = new SVGSprite(viewObj2);

      targetSprite.addChild(this.spt);
      targetSprite.addChild(this.spt2);

      // 初期は非表示
      this.spt.visible = false;
      this.spt2.visible = false;
      this.spt.update();
      this.spt2.update();
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      if (this.firstDot === undefined || this.secondDot === undefined) return;

      // 中心点
      const centerPoint: marietta.core.Point = marietta.core.Point.interpolate(this.firstDot, this.secondDot, 0.5);

      // 面積計算用、頂点リストの作成
      const dotList = [];
      dotList.push(new marietta.core.Point(Math.min(this.firstDot.x, this.secondDot.x), Math.min(this.firstDot.y, this.secondDot.y)));
      dotList.push(new marietta.core.Point(Math.max(this.firstDot.x, this.secondDot.x), Math.min(this.firstDot.y, this.secondDot.y)));
      dotList.push(new marietta.core.Point(Math.max(this.firstDot.x, this.secondDot.x), Math.max(this.firstDot.y, this.secondDot.y)));
      dotList.push(new marietta.core.Point(Math.min(this.firstDot.x, this.secondDot.x), Math.max(this.firstDot.y, this.secondDot.y)));

      const heibei = String(`${marietta.webcad.util.WebCADUtil.calculateArea(dotList)}㎡`);
      const tubo: number = marietta.webcad.util.WebCADUtil.calculateAreaInTsubo(dotList);
      let tuboString;
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en':
          if (tubo === Math.round(tubo)) {
            tuboString = `(${String(tubo)}.0jyou)`;
          } else {
            tuboString = `(${String(tubo)}jyou)`;
          }
          break;
        default:
          if (tubo === Math.round(tubo)) {
            tuboString = `(${String(tubo)}.0帖)`;
          } else {
            tuboString = `(${String(tubo)}帖)`;
          }
          break;
      }
      const distance: number = Math.max(this.firstDot.x, this.secondDot.x) - Math.min(this.firstDot.x, this.secondDot.x);
      this.viewObj.textContent = heibei;
      this.viewObj2.textContent = tuboString;

      const bound1 = this.viewObj.getBoundingClientRect();
      const bound2 = this.viewObj2.getBoundingClientRect();
      const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
      const sc: number = 1 / root.scaleX;

      if (bound1.width < bound2.width) {
        this.viewObj.setAttribute('x', (centerPoint.x - (bound2.width / 2) * sc + ((bound2.width - bound1.width) / 2) * sc).toString());
        this.viewObj2.setAttribute('x', (centerPoint.x - (bound2.width / 2) * sc).toString());
      } else {
        this.viewObj.setAttribute('x', (centerPoint.x - (bound1.width / 2) * sc).toString());
        this.viewObj2.setAttribute('x', (centerPoint.x - (bound1.width / 2) * sc + ((bound1.width - bound2.width) / 2) * sc).toString());
      }
      this.viewObj.setAttribute('y', (centerPoint.y - (bound1.height / 2) * sc).toString());
      this.viewObj2.setAttribute('y', (centerPoint.y + (bound1.height / 2) * sc).toString());

      this.spt.visible = this.minVisibleDistance < distance;
      this.spt2.visible = this.minVisibleDistance < distance;
      this.spt.update();
      this.spt2.update();
    }

    /**
     * HTMLElementの取得
     */
    public get viewObj(): HTMLElement {
      return this.spt.element;
    }

    /**
     * HTMLElementの取得
     */
    public get viewObj2(): HTMLElement {
      return this.spt2.element;
    }

    /**
     * 表示ON
     */
    show() {
      this.spt.element.style.visibility = 'visible';
      this.spt2.element.style.visibility = 'visible';
    }

    /**
     * 表示ON
     */
    hide() {
      this.spt.element.style.visibility = 'hidden';
      this.spt2.element.style.visibility = 'hidden';
    }
}
